import MainLayout from "./mainLayout";

export  default MainLayout;